import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoyaltyBoosterButton from "components/atoms/LoyaltyBoosterButton";
import { GET_POPUP_TYPES } from "constants/popupConfig";
import { useGetBoostersUser } from "queries/useGetBoostersUser";
import { formatBoosters } from "utils/booster";
import { useLoyaltyStore } from "stores/loyalty";

type LoyaltyBoosterButtonContainerProps = {
  id?: string;
  classNames?: string;
};

export const LoyaltyBoosterButtonContainer: FC<
  LoyaltyBoosterButtonContainerProps
> = ({ id, classNames }) => {
  const { boosters } = useGetBoostersUser();
  const { activeBooster, availableBooster } = formatBoosters(boosters);
  const isActiveBooster = !!activeBooster;
  const contextOnboardIsOpen = useLoyaltyStore(
    (state) => state.contextOnboardingOpen,
  );
  const booster = activeBooster || availableBooster;
  const navigate = useNavigate();
  const location = useLocation();
  const showBooster = !!booster && !contextOnboardIsOpen;

  const onHandleClickBooster = () => {
    if (isActiveBooster) {
      navigate(
        `${location.pathname}?popup=${GET_POPUP_TYPES.popup.boosterActivate}`,
      );
    } else {
      navigate(
        `${location.pathname}?popup=${GET_POPUP_TYPES.popup.boosterInfo}`,
      );
    }
  };

  if (!showBooster) {
    return null;
  }

  return (
    <LoyaltyBoosterButton
      id={id}
      booster={booster}
      handleClick={onHandleClickBooster}
      className={classNames}
    />
  );
};
